import { render, staticRenderFns } from "./IdeaTrays.vue?vue&type=template&id=470abefb&"
import script from "./IdeaTrays.vue?vue&type=script&lang=js&"
export * from "./IdeaTrays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports